<div>
    <canvas baseChart
            [type]="'bar'"
            [data]="chartData"
            [options]="chartOptions"
            [legend]="chartLegend">
    </canvas>
</div>
